// extracted by mini-css-extract-plugin
export default {"header":"HederWithSettings_header__dKg2L"};